import { coachEndpoints } from './coach-endpoints';
import { piloteerApi } from './piloteer';

export { coachAdminQueryOptions, coachQueryOptions } from './coach-endpoints';
export const coachApi = piloteerApi.injectEndpoints({
  endpoints: coachEndpoints,
});
export const {
  useGetCoachCompanyAnalyticsQuery,
  useGetCoachTeamAnalyticsQuery,
  useGetMyCoachesQuery,
  useGetCoachProfileQuery,
  useGetCoachAssignmentsQuery,
  useGetCoachCompaniesQuery,
  useGetCoachTeamsQuery,
  useGetCoachScoreboardQuery,
  useGetCoachTrendsQuery,
  useGetCoachObjectivesQuery,
  useGetCoachPerformanceLoopQuery,
  useGetCompanyCoachesQuery,
  useGetCoachAssignmentsAdminQuery,
  useGetCompanyCoachAssignmentsQuery,
  useAssignMemberToCoachMutation,
  useUnassignMemberFromCoachMutation,
  useAdminListCoachesQuery,
  useLazyAdminLookupPartnerCandidateQuery,
  useAdminUpdatePartnerMutation,
} = coachApi;
